import smoothscroll from 'smoothscroll-polyfill';

export default class SmoothScroll {
  constructor (anchorLinkBtnElem) {
    anchorLinkBtnElem.addEventListener('click', this.addEvent);
  }

  addEvent (event) {
    event.preventDefault();
    smoothscroll.polyfill();
    const targetId = this.hash;
    const targetElement = document.querySelector(targetId);
    const targetOffsetTop = window.pageYOffset + targetElement.getBoundingClientRect().top;
    window.scrollTo({
      top: targetOffsetTop,
      behavior: 'smooth'
    });
  }
}
